<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Guest Register</div>
        <div class="box-mini mb-10">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-md-3">
                <table>
                  <tr>
                    <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                    <td>
                      <flat-pickr :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-sm-3">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Branch
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-3" v-if="getRoleId != 3">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Sales
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="sales" v-model="sales_id" @change="changeSales">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataSales" :key="item.id" :value="item.id">{{item.fullname}}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-md-3 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" class="table-fixedwidth">
              <template v-slot:cell(name)="data">
                {{data.item.first_name}} {{data.item.last_name}}
              </template>
              <template v-slot:cell(birthday)="data">
                {{getAge(data.item.birthday)}}
              </template>
              <template v-slot:cell(status_guest)="data">
                <template v-if="data.item.member">
                  <template v-if="data.item.member.membership && data.item.member.membership.is_trial == 0">
                    Join
                  </template>
                </template>
                <template v-else-if="data.item.member">
                  <template v-if="data.item.member.membership && data.item.member.membership.is_trial == 1">
                    Trial
                  </template>
                </template>
                <template v-else>MG</template>
              </template>
              <template v-slot:cell(effective_date)="data">
                <template v-if="data.item.member">
                  <template v-if="data.item.member.membership && (data.item.member.membership.is_trial == 0 || data.item.member.membership.is_trial == 1)">
                    {{data.item.member.effective_date}}
                  </template>
                </template>
                <template v-else>-</template>
              </template>
              <template v-slot:cell(guest_type)="data">
                <div v-if="data.item.leads_eha_form">
                  {{data.item.leads_eha_form.question_guess_type}}
                </div>
              </template>
              <template v-slot:cell(sh_value)="data">
                <div v-if="data.item.emptyEhaForm === false">
                  1
                </div>
                <div v-else>
                  0
                </div>
              </template>
              <template v-slot:cell(countDues)="data">
<!--              <template slot="countDues" slot-scope="data">-->
                {{getDues(data.item.member)}}
              </template>
              <template v-slot:cell(countTerm)="data">
<!--              <template slot="countTerm" slot-scope="data">-->
                {{getTerm(data.item.member)}}
              </template>
              <template v-slot:cell(guest_pass)="data">
<!--              <template slot="guest_pass" slot-scope="data">-->
                <div v-if="data.item.leads_eha_form">
                  {{getGuestPass(data.item.leads_eha_form.question_guess_pass)}}
                </div>
              </template>
              <template v-slot:cell(countMember)="data">
<!--              <template slot="countMember" slot-scope="data">-->
                <template v-if="data.item.member">
                  <template v-if="data.item.member.membership">
                    1
                  </template>
                </template>
                <div v-else>0</div>
              </template>
              <template v-slot:cell(countMG)="data">
<!--              <template slot="countMG" slot-scope="data">-->
                <template v-if="data.item.member">
                  <template v-if="data.item.member.membership">
                    0
                  </template>
                </template>
                <div v-else>1</div>
              </template>
              <template v-slot:cell(bottom-row)="">
                <td colspan="11"><strong>Total</strong></td>
                <td><strong>{{totalSH}}</strong></td>
                <td><strong>{{totalInterview}}</strong></td>
                <td><strong>{{totalDue}}</strong></td>
                <td><strong>{{totalTerm}}</strong></td>
                <td><strong>{{totalGuestPass}}</strong></td>
                <td><strong>{{totalMemberReff}}</strong></td>
                <td><strong>{{totalMG}}</strong></td>
                <td></td>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </div>
        <div class="box-mini">
          <div class="p-15">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Dues</th>
                    <th>Term</th>
                    <th>Total Join</th>
                    <th>Not Join</th>
                    <th>Total Guest</th>
                    <th>Interview</th>
                    <th>Close%</th>
                    <th>Member Reff</th>
                    <!-- <th>Total Reff</th> -->
                    <th>Shows</th>
                    <th>Guest Pass Issued</th>
                    <th>Guest Pass Missed</th>
                    <th>Given%</th>
                  </tr>
                </thead>
                <tbody v-if="this.itemSummary">
                  <tr>
                    <td> {{ this.itemSummary.dues }}</td>
                    <td> {{ this.itemSummary.term }}</td>
                    <td> {{ this.itemSummary.total_join }}</td>
                    <td> {{ this.itemSummary.not_join }}</td>
                    <td> {{ this.itemSummary.total_guest }}</td>
                    <td> {{ this.itemSummary.shows }}</td>
                    <td> {{ isNaN(this.itemSummary.close) ? 0 : this.itemSummary.close }}%</td>
                    <td> {{ this.itemSummary.member_reff }}</td>
                    <td> {{ this.itemSummary.shows }}</td>
                    <td> {{ this.itemSummary.guest_pass_issued }}</td>
                    <td> {{ this.itemSummary.guest_pass_missed }}</td>
                    <td> {{ isNaN(this.itemSummary.given) ? 0 : this.itemSummary.given }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'guestregister',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'member.member_id',
          label: 'Member ID',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: true
        },
        {
          key: 'name',
          label: 'Full Name',
          sortable: true
        },
        {
          key: 'birthday',
          label: 'Age',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'sale.membership_advisor_name',
          label: 'Membership Advisor Name',
          sortable: true
        },
        {
          key: 'emptyEhaForm',
          label: 'EHA Form Complete',
          formatter: (value, key, item) => {
            return item.emptyEhaForm ? 'No' : 'Yes'
          },
          sortable: true
        },
        {
          key: 'guest_type',
          label: 'Guest Type',
          sortable: true
        },
        {
          key: 'leads_source_type.source_lead',
          label: 'Source Lead',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Join Date',
          sortable: false,
          formatter: (value, key, item) => {
            if (item.countDues == 1 || item.countTerm == 1) {
              return  moment(item.created_at).format('YYYY-MM-DD')
            } else {
              return  '-'
            }
          }
        },
        {
          key: 'effective_date',
          label: 'Eff. Date',
          sortable: false
        },
        {
          key: 'status_guest',
          label: 'Join / MG / Trial',
          sortable: false
        },
        {
          key: 'sh_value',
          label: 'Show',
          sortable: false
        },
        {
          key: 'show_status',
          label: 'Show Status',
          sortable: false
        },
        {
          key: 'interview',
          label: 'Interview',
          formatter: (value, key, item) => {
            return item.emptyEhaForm ? 'No' : 'Yes'
          },
          sortable: true
        },
        {
          key: 'countDues',
          label: 'Dues',
          sortable: false
        },
        {
          key: 'countTerm',
          label: 'Term',
          sortable: false
        },
        {
          key: 'guest_pass',
          label: 'Guest Pass',
          sortable: false
        },
        {
          key: 'countMember',
          label: 'Member Reff',
          sortable: false
        },
        {
          key: 'countMG',
          label: 'MG Reff',
          sortable: false
        },
        {
          key: 'leads_eha_form.sale.toured_by',
          label: 'Toured By',
          sortable: false
        },
        {
          key: 'leads_eha_form.updated_at',
          label: 'EHA Form Date',
          sortable: false,
          formatter: (value, key, item) => {
            return item.leads_eha_form ? moment(item.leads_eha_form.updated_at).format('YYYY-MM-DD HH:mm:ss') : '-'
          }
        }
      ],
      itemSummary: null,
      dateWeek: '',
      items: [],
      dataBranch: [],
      branch_id: null,
      dataSales: [],
      sales_id: null,
      totalItems: [],
      totalCount: '',
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 20,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      dateString: '27-07-1993',
      totalJoinMembership: null,
      totalJoinMember: null,
      notJoinMember: null,
      notJoinMembership: null,
      totalGuest: null,
      // startDate: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY-MM-DD'),
      // endDate: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('YYYY-MM-DD'),
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        onChange: this.onChange
      },
    }
  },
  computed: {
    totalSH: function(){
      return this.items.filter(item => item.emptyEhaForm === false).length
    },
    totalInterview: function(){
      return this.items.filter(item => item.emptyEhaForm === false).length
    },
    totalDue: function() {
      return this.items.filter(item => item.member !== null && item.member.membership !== null && item.member.membership.membership_type_id === 1).length
    },
    totalTerm: function() {
      return this.items.filter(item => item.member !== null && item.member.membership !== null && item.member.membership.membership_type_id === 2).length
    },
    totalGuestPass: function() {
      return this.items.filter(item => item.leads_eha_form && item.leads_eha_form.question_guess_pass !== 'no' && item.leads_eha_form.question_guess_pass !== '').length
    },
    totalMemberReff: function() {
      return this.items.filter(item => item.member && item.member.membership).length
    },
    totalMG: function() {
      return this.items.filter(item => {
        if (!item.member) return true
        if (item.member && !item.member.membership) return true
      }).length
    }
  },
  methods: {
    onChange(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
              this.totalData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
      this.totalData()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    getAge(value)
    {
      var today = new Date();
      var birthDate = new Date(value);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
      {
          age--
      }
      return age
    },
    getGuestType(value) {
      // console.log('test', value)
      var dataValue
      if (value === 'appointment') {
        dataValue = 1
      }else {
        dataValue = 0
      }
      return dataValue
    },
    getDues(value)
    {
      var data = value
      var dataValue
      if (data !== null && data !== undefined) {
        if (data.membership !== null && data.membership.membership_type_id === 1) {
          dataValue = 1
        }
      }
      else {
        dataValue= 0
      }
      return dataValue
    },
    getTerm(value)
    {
      var data = value
      // console.log("getTerm", data)
      var dataValue
      if (data !== null && data !== undefined) {
        if (data.membership !== null && data.membership.membership_type_id === 2) {
          dataValue = 1
        }
      }
      else {
        dataValue= 0
      }
      return dataValue
    },
    getGuestPass(value)
    {
      var data = value
      var dataValue
      if (data === 'no') {
        dataValue = 0
      }
      else if (data === '') {
        dataValue = 0
      }
      else {
        dataValue = 1
      }
      return dataValue
    },
    getMember(value)
    {
      var data = value
      var dataValue
      if (data) {
        dataValue = 1
      }
      else {
        dataValue = 0
      }
      return dataValue
    },
    getMG(value)
    {
      var data = value
      var dataValue = 0
      if (data === null) {
        dataValue = 1
      }
      else {
        dataValue = 0
      }
      return dataValue
    },
    getClosePercentage(value, value2)
    {
      var data = value
      var percentage = (data/value2) * 100
      return percentage.toFixed(2)
    },
    getMemberNotJoin (value1, value2) {
      var data = value1 - value2
      return data
    },
    getClosePercentage2(value, value2)
    {
      var data = value
      var percentage = (data/value2) * 100
      return percentage.toFixed(2)
    },
    checkForm(event) {
      return event.emptyEhaForm === true
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/sales_report/guest_register_new?leads_already_assign_status=true&emptyEhaForm=false&start='+dates[0]+'&end='+dates[1]

      if (this.branch_id != null) url += '&branch_id=' + this.branch_id
      if (this.sales_id != null) url += '&owner_id=' + this.sales_id
      if (this.getRoleId == 3) url += '&owner_id=' + Auth.Session.get().paradigm_id

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Guest Register (Guest Register Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    changeBranch (event) {
      this.loadingActive = true
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/guest_register?leads_already_assign_status=true&emptyEhaForm=false'
      + '&start=' + dates1[0]
      + '&end=' + dates1[1]
      + '&page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData

      let url2 = `crm/v1/sales_report/guest_register/summary?start=${dates1[0]}&end=${dates1[1]}&leads_already_assign_status=true&emptyEhaForm=false`

      if (event != null) {
        url += '&branch_id=' + event
        url2 += '&branch_id=' + event
      }

      if (this.sales_id != null) {
        url += '&owner_id=' + this.sales_id
        url2 += '&owner_id=' + this.sales_id
      }

      if (this.getRoleId == 3) {
        url += '&owner_id=' + Auth.Session.get().paradigm_id
        url2 += '&owner_id=' + Auth.Session.get().paradigm_id
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get(url2)
      .then(response => {
        this.itemSummary = response.data
      }).catch(error => {
        console.log('error', error)
      })


    },
    changeSales(event) {
      this.sales_id = event
      this.changeBranch(this.branch_id)
    },
    fetchData() {
      this.loadingActive = true
      let dates1 = this.exportDates.split(' to ')

      let url = 'crm/v1/sales_report/guest_register?leads_already_assign_status=true&emptyEhaForm=false'
      + '&start=' + dates1[0]
      + '&end=' + dates1[1]
      + '&page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData

      if (this.branch_id != null) url += '&branch_id=' + this.branch_id
      if (this.sales_id != null) url += '&owner_id=' + this.sales_id
      if (this.getRoleId == 3) url += '&owner_id=' + Auth.Session.get().paradigm_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount

        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })

      axios.get(`crm/v1/sales_report/guest_register/total?start=${dates1[0]}&end=${dates1[1]}&leads_already_assign_status=true&emptyEhaForm=false`)
      .then(response => {
        this.itemSummary = response.data
        console.log('test data', response.data)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/sales?sorting=fullname&sorting_type=asc').then(response => {
        this.dataSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

    },
    totalData() {
      let dates2 = this.exportDates.split(' to ')
      axios.get('crm/v1/sales_report/guest_register?start=' + dates2[0] + '&end=' + dates2[1] + '&leads_already_assign_status=true&emptyEhaForm=false').then(response => {
        var getTotalData = response.data.data.rows
        this.totalItems = getTotalData.filter(item => item.member && item.member.membership && item.member.membership.is_revenue == 1)
        this.totalCount = response.data.data.count
        this.totalJoinMember = this.totalItems.filter(item => item.member && item.emptyEhaForm === false).length
        this.totalJoinMembership = this.totalItems.filter(item => item.member && item.member.membership_id && item.emptyEhaForm === false).length
        this.totalGuest = getTotalData.filter(item => item.member && item.emptyEhaForm === false).length
        this.notJoinMember = this.totalGuest - this.totalJoinMember
        this.notJoinMembership = this.totalGuest - this.totalJoinMembership
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
    // this.totalData()
  }
}
</script>
